export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5681.67ffe186.jpg";